import PropTypes from "prop-types";
import { Helmet } from "react-helmet-async";
import { forwardRef } from "react";
// material
import { Box } from "@mui/material";

const Page = forwardRef(({ children, title = "", ...other }, ref) => {
  return (
    <Box
      ref={ref}
      {...other}
      sx={{
        ...((other && other.sx) || {}),
        height: { md: "calc(100vh - 130px)", xs: "calc(100vh - 7.3rem)" },
      }}
    >
      <Helmet>
        <title>{title} | Afritas</title>
      </Helmet>
      {children}
    </Box>
  );
});

Page.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
};

export default Page;
